import React from "react";
import { Link, useParams } from "react-router-dom";
import projects from "../../../data/projects";
import "./Project.css";
import Footersec from "../Footersec/Footersec";
import { useTranslation } from "react-i18next";

export const Project = () => {
  const { t } = useTranslation();
  const params = useParams();
  const item = projects.find((elem) => {
    return elem.project === params.project && elem;
  });
  // console.log("QweRTyuI", item.whatChallengedToDo);
  return (
    <div>
      <Link
        to="/"
        // style={{ position: "sticky", top: "10px" }}
        className="btn-back"
      >
        <svg
          className="btn-svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          height="30px"
          width="30px"
        >
          <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.42L6.83 13H21v-2z" />
        </svg>
      </Link>
      <div className="project">
        <h1 className="project__title">{item.project}</h1>
        {/* <h2 className="project__text">{item.whatOurClientDo}</h2> */}
        <h2 className="project__text">{t(`Projects/projectId${item.id}WhatOurClientDo`)}</h2>
        <img src={item.img} alt="" style={{ maxWidth: "100%" }} />
        <div className="project-container">
          <h2 className="project__list-title">{t("Project/Summary")}</h2>
          <ul className="project__list">
            {/* <li className="project__list-item">
            <h3>Country</h3>
            <p>{item.country}</p>
          </li>
          <li className="project__list-item">
            <h3>Stacks used</h3>
            <p>{item.stacksUsed}</p>
          </li>
          <li className="project__list-item">
            <h3>Resources used</h3>
            <p>{item.resourcesUsed}</p>
          </li>
          <li className="project__list-item">
            <h3>Work duration</h3>
            <p>{item.duration}</p>
          </li> */}
            <li className="project__list-item">
              <h3>{t("Project/Client")}</h3>
              <p className="list-item__text">{item.client}</p>
            </li>
            <li className="project__list-item">
              <h3>{t('Project/Country')}</h3>
              {/* <p className="list-item__text">{item.country}</p> */}
              <p className="list-item__text">{t(`Projects/projectId${item.id}Country`)}</p>
            </li>
            <li className="project__list-item">
              <h3>{t('Project/Industry')}</h3>
              {/* <p className="list-item__text">{item.industry}</p> */}
              <p className="list-item__text">{t(`Projects/projectId${item.id}Industry`)}</p>
            </li>
            <li className="project__list-item">
              <h3>{t('Project/Type of service')}</h3>
              {/* <p className="list-item__text">{item.typeOfService}</p> */}
              <p className="list-item__text">{t(`Projects/projectId${item.id}TypeOfService`)}</p>
            </li>
          </ul>
          <div className="challenge_to-do">
            <h2 className="to-do__title">{t("Project/What we've challenged to do")}</h2>
            {/* <p>{item.whatChallengedToDo.mainText}</p> */}
            <p>{t(`Projects/projectId${item.id}WhatChallengedToDoMainText`)}</p>
            <div>
              {item.whatChallengedToDo.list &&
                // item.whatChallengedToDo.list.map((e) => <p>{e}</p>)}
                item.whatChallengedToDo.list.map((e, index) => <p>{t(`Projects/projectId${item.id}WhatChallengedToDoList${index + 1}`)}</p>)}
            </div>
          </div>
          {item.whatDone.mainText && (
            <div className="what__Done">
              <h2 className="what__Done-title">{t("Project/What we've done")}</h2>
              {/* < p > {item.whatDone.mainText}</p> */}
              < p > {t(`Projects/projectId${item.id}WhatDoneMainText`)}</p>
              <div>
                {item.whatDone.list.map((e, index) => (
                  // <p>{e}</p>
                  <p>{t(`Projects/projectId${item.id}WhatDoneList${index + 1}`)}</p>
                ))}
              </div>
            </div>
          )}
          <div className="delivered">
            <h2 className="delivered-title">{t("Project/What we've delivered")}</h2>
            {/* < p > {item.whatDelivered.mainText}</p> */}
            < p > {t(`Projects/projectId${item.id}WhatDeliveredMainText`)}</p>
            <div>
              {item.whatDelivered.list &&
                // item.whatDelivered.list.map((e) => <p>{e}</p>)}
                item.whatDelivered.list.map((e, index) => <p>{t(`Projects/projectId${item.id}WhatDeliveredList${index + 1}`)}</p>)}
            </div>
          </div>
          <div className="stacks__used">
            <h2 className="stacks__used-title">{t('Project/Stacks used')}</h2>
            {/* <p>{item.stacksUsed}</p> */}
            <p>{t(`Projects/projectId${item.id}StacksUsed`)}</p>
          </div>
          <div className="resources__used">
            <h2 className="resources__used-title">{t('Project/Resources used')}</h2>
            {/* <p>{item.resourcesUsed}</p> */}
            <p>{t(`Projects/projectId${item.id}ResourcesUsed`)}</p>
          </div>
          <div className="app-body">
            <a href={item.appForIOS} className="app" target="_blanck">
              {t('Project/delivered app for iOS')}
            </a>
            {item.appForAndroid && (
              <a href={item.appForAndroid} className="app">
                {t('Project/delivered app for android')}
              </a>
            )}
          </div>
        </div>
      </div>
      <Footersec />
    </div>
  );
};
